import logger from './log';

export default () => {
  if (window.extellio.embedded) {
    import(/* webpackChunkName: "resizer-child" */ 'iframe-resizer/js/iframeResizer.contentWindow').catch(e => logger('iframeResizer', e));
  }
};
